<script>
   export default {
    components: { },
    props: {
      canal: {
        required: true
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        imgUsuario: "/img/chat/perfilIndividual.png",
      }
    },
    computed: {

    },
    methods: {
      selecionarCanal() {
        this.$emit('iniciarChatCanal', {
          'idUsuarioDestino': this.canal.idUsuarioDestino,
          'idCanal': this.canal.idCanal,
          'nomeUsuario': this.canal.nomeUsuario,
        })
      }
    }
  }
</script>

<template>
  <div class="containerCanal" @click="selecionarCanal">
    <img :src="imgUsuario" class="imagemUsuarioCanal" />
    <div class="lblUsuarioConversaNome">{{canal.nomeUsuario}}</div>
  </div>
</template>

<style>
  .containerCanal {
    display: grid;
    align-items: center;
    justify-content: left;
    height: 58px;
    width: 100%;
    background-color: white;
    grid-template-columns: 64px 240px;
    cursor: pointer;
    border-bottom: 0.05rem solid #13141f17;
  }

  .containerCanal:hover {
    background-color: #F0F2F5;
  }

  .containerCanal:not( :hover ) {
    background-color: white;
  }

  .imagemUsuarioCanal {
    height: 36px;
    width: 36px;
    margin-left: 8px;
  }

  .lblUsuarioConversaNome {
    font-size: 12px;
    font-family: sans-serif;
    color: black;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/chat/componentes/Canais.vue